import { sanitizeUrl } from 'shared-widget-components/src/utils/sanitizeUrl';
import { truncateHtml } from 'shared-widget-components/src/utils/truncateHtml';

interface CustomSlideButtonProps {
  buttonColor: string;
  buttonTextColor: string;
  slideContent: any;
}

/**
 * CustomSlideButton component
 * this component is responsible for rendering the button of the custom slide
 * @param buttonColor - button color of the custom slide
 * @param buttonTextColor - button text color of the custom slide
 * @param slideContent - content of the custom slide
 * @returns CustomSlideButton component
 */

export const CustomSlideButton = ({ slideContent, buttonColor, buttonTextColor }: CustomSlideButtonProps) => {
  // ha nincs buttonText vagy buttonLink, akkor return
  if (!slideContent.buttonText || !slideContent.buttonLink) return <></>;

  // a button szöveg rövidítése megadott karakterszámra
  const truncatedButtonText = truncateHtml(slideContent.buttonText, 20);

  //@ts-ignore
  const isAdmin = window.isAdminPage;

  // a gombra kattintáskor történő esemény
  const handleNavigation = () => {
    if (isAdmin) return;
    const url = sanitizeUrl(slideContent.buttonLink);
    window.location.href = url;
  };

  return (
    <button
      type='button'
      onClick={handleNavigation}
      disabled={isAdmin}
      className={`rounded mt-auto min-[350px]:font-semibold sm:font-medium min-[350px]:w-full sm:w-fit min-[350px]:text-[14px] sm:text-[16px]  px-3  py-2 cursor-pointer font-body`}
      style={{ backgroundColor: buttonColor, color: buttonTextColor, cursor: isAdmin ? 'not-allowed' : 'pointer' }}
    >
      {truncatedButtonText}
    </button>
  );
};
